// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"5b1e79dc532bf6c726c7","655":"b8b1df0a44a05b7843e0"}[chunkId] + ".js";
};